var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { onError } from "@ane/core/lib/decorators/OnError";
import { RestServiceBase } from "@ane/core/lib/services/RestServiceBase";
import { continuationErrorMessage } from "../constants/FeatureDataConstants.js";
import { expAdapterService } from "../services/middlewares/ExpAdapterMiddleware.js";
import { WPSProxyConverter } from "@ane/core/lib/services/WPSProxy";
import EnvironmentService from "@ane/core/lib/services/EnvironmentService";
var __defProp2 = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp2(target, key, result);
  return result;
};
let FeatureReadV2Resources = class extends RestServiceBase {
  constructor() {
    super(EnvironmentService.endpoints.legacy, "/api/");
    __publicField(this, "version", "2.0");
  }
  loadProgressionsForFeature(featureId, onlyArchivedProgressions = false) {
    return __async(this, null, function* () {
      const address = `${this.version}/features/${featureId}/progressions?onlyArchivedProgressions=${onlyArchivedProgressions}`;
      const result = yield this._get(address);
      const json = result.getSuccessData();
      return json;
    });
  }
  loadProgression(featureId, progressionId) {
    return __async(this, null, function* () {
      const address = `${this.version}/features/${featureId}/progressions/${progressionId}`;
      const result = yield this._get(address);
      const json = result.getSuccessData();
      return json;
    });
  }
  loadProgressionsRestResult(featureId, onlyArchivedProgressions = false, onlyNonArchived = false) {
    return __async(this, null, function* () {
      const address = `${this.version}/features/${featureId}/progressions?onlyArchivedProgressions=${onlyArchivedProgressions}&onlyNonArchived=${onlyNonArchived}`;
      const result = yield this._get(address);
      return result;
    });
  }
  loadProgressionRestResult(featureId, progressionId) {
    return __async(this, null, function* () {
      const address = `${this.version}/features/${featureId}/progressions/${progressionId}`;
      return yield this._get(address);
    });
  }
};
__decorateClass([
  onError({ message: `An error occurred while loading the progressions for the feature. ${continuationErrorMessage}` })
], FeatureReadV2Resources.prototype, "loadProgressionsForFeature", 1);
__decorateClass([
  onError({ message: `An error occurred while loading the progression. ${continuationErrorMessage}` })
], FeatureReadV2Resources.prototype, "loadProgression", 1);
FeatureReadV2Resources = __decorateClass([
  WPSProxyConverter(),
  expAdapterService()
], FeatureReadV2Resources);
const FeatureReadV2Resource = new FeatureReadV2Resources();
export {
  FeatureReadV2Resources,
  FeatureReadV2Resource as default
};
//# sourceMappingURL=FeatureReadV2Resource.js.map
